import React, { VFCX } from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';

import HomeIcon from './home-icon';
import BlogIcon from './blog-icon';
import ContactIcon from './contact-icon';

type Props = {
  toggleDrawer: () => void;
};

const Component: VFCX<Props> = ({ className, toggleDrawer }) => (
  <div className={className}>
    <Link to='/' onClick={toggleDrawer}>
      <HomeIcon />
      <p>HOME</p>
    </Link>
    <Link to='/skills' onClick={toggleDrawer}>
      <BlogIcon />
      <p>SKILL</p>
    </Link>
    <Link to='/projects' onClick={toggleDrawer}>
      <BlogIcon />
      <p>PROJECT</p>
    </Link>
    <Link to='/contact' onClick={toggleDrawer}>
      <ContactIcon />
      <p>CONTACT</p>
    </Link>
  </div>
);

const StyledComponent = styled(Component)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;

  & > a {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0 1em;
    font-size: 1.4rem;
    text-decoration: none;
    color: var(--color-primary-dark);
    fill: var(--color-primary-dark);
    min-width: 50px;
    padding: 16px 32px 16px 16px;

    & > svg {
      margin-right: 8px;
      width: 24px;
    }
  }
`;

export default StyledComponent;
